import {
  APP_INITIALIZER,
  ApplicationConfig,
  enableProdMode,
  importProvidersFrom,
  provideZoneChangeDetection,
} from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient, withInterceptors,
  withInterceptorsFromDi,
} from "@angular/common/http";
// Other module imports
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { provideToastr } from "ngx-toastr";
import { provideStore, StoreModule } from "@ngrx/store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { EffectsModule, provideEffects } from "@ngrx/effects";
import { routes } from "./app.routes";
import { provideRouter } from "@angular/router";
import { provideAnimations } from "@angular/platform-browser/animations";
import { BsDropdownConfig } from "ngx-bootstrap/dropdown";
import { environment } from "../environments/environment";
import { FacebookAccountService } from "./core/services/facebook-account.service";
import { Constants } from './core/helpers/constants';
import {AuthInterceptor} from "./core/helpers/auth.interceptor";  // Import Constants class
import {ErrorInterceptor} from "./core/helpers/error.interceptor";
import {ActiveOrgInterceptor} from "./core/helpers/active-org.interceptor";

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, "assets/i18n/", ".json");
}

// The appInitializer function using FacebookAccountService
// NOTE: Facebook features are temporarily disabled. The FB SDK calls below are
// commented out and the initializer resolves immediately so the app boots
// without loading the Facebook SDK.
export function appInitializer(facebookAccountService: FacebookAccountService) {
  return () => new Promise<void>((resolve) => {
    // const facebookCredentials = Constants.getFacebookInitCredential(); // Get credentials from Constants
    //
    // window['fbAsyncInit'] = function () {
    //   FB.init({
    //     appId: facebookCredentials.appId, // Use appId from the static method
    //     cookie: facebookCredentials.cookie,
    //     xfbml: facebookCredentials.xfbml,
    //     version: facebookCredentials.version, // Use version from the static method
    //   });
    //
    //   // Auto authenticate with the API if already logged in with Facebook
    //   FB.getLoginStatus(({authResponse}) => {
    //     if (authResponse) {
    //       facebookAccountService.apiAuthenticate(authResponse.accessToken)
    //         .subscribe()
    //         .add(resolve); // Resolve the promise after authentication
    //     } else {
    //       resolve(); // No authentication needed, resolve immediately
    //
    //     }
    //   });
    // };
    //
    // // Load Facebook SDK script
    // (function (d, s, id) {
    //   var js, fjs = d.getElementsByTagName(s)[0];
    //   if (d.getElementById(id)) {
    //     return;
    //   }
    //   js = d.createElement(s);
    //   js.id = id;
    //   js.src = 'https://connect.facebook.net/en_US/sdk.js';
    //   fjs.parentNode.insertBefore(js, fjs);
    // })(document, 'script', 'facebook-js-sdk');

    resolve();
  });
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient],
        },
      }),
    ),
    provideAnimations(),
    provideToastr(),
    {
      provide: BsDropdownConfig,
      useValue: { isAnimated: true, autoClose: true },
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ActiveOrgInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: appInitializer,
    //   deps: [FacebookAccountService],
    //   multi: true
    // },
  ],
};
